var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { useGetList } from 'react-admin';
import { useTranslate } from 'ra-core';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
/**
 * A React Admin custom field to display the number of applications using
 * the current API.
 * Meant to be used in an API view.
 */
export const ApiApplicationUsageField = props => {
    const { className, record } = props, rest = __rest(props, ["className", "record"]);
    const translate = useTranslate();
    const classes = useStyles(props);
    const { data, loaded, error } = useGetList('applications', undefined, { field: 'name', order: 'ASC' }, {
        apiUuid: record.id,
    });
    if (!loaded) {
        return React.createElement(LinearProgress, null);
    }
    if (!data || error) {
        return (React.createElement(Typography, Object.assign({ variant: "body2", className: classes.error }, rest), translate('ra.page.error')));
    }
    return (React.createElement(Typography, Object.assign({ variant: "body2", className: classNames(className, classes.root) }, rest), data && Object.keys(data).length));
};
const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.primary.main,
    },
    error: {
        color: theme.palette.error.main,
        marginBottom: theme.spacing(),
    },
}), {
    name: 'Layer7ApiApplicationUsageField',
});
//# sourceMappingURL=ApiApplicationUsageField.js.map